import {evite} from 'evite';
import * as _mobxReact from 'node-modules-mobx-react';

Object.assign(exports, _mobxReact);
evite.assert(_mobxReact.inject, 'Possibly using a minified version of mobx-react');

window.mobxReact = exports;
evite.set(evite, 'exports.mobxReact', exports);
